export default __webpack_public_path__ + "images/K6.238f21b.png";